import { Link } from 'react-router-dom';
import './home.css';
import { useEffect, useRef, useState } from 'react';
import banner1 from '../../banner/banner1.jpg';
import banner2 from '../../banner/banner2.jpg';
import banner3 from '../../banner/banner3.jpg';
import banner4 from '../../banner/banner4.jpg';
import banner5 from '../../banner/banner5.jpg';
import banner6 from '../../banner/banner6.jpg';
import Downloadapp from '../../component/downloadapp/Downloadapp';
import Bestproduct from '../../component/bestproduct/Bestproduct';
import News from '../../component/news/News'
import imagebanner from '../../image/homebanner.png'
import womanbanner from '../../image/womanbanner.png'
import tree from '../../image/tree.png'
import newyear from '../../image/2025.png'


const images = [banner1, banner2, banner3, banner4, banner5, banner6];

export default function Home(props) {

    const [currentIndex, setCurrentIndex] = useState(0);
    const timeoutRef = useRef(null);

    const preloadImages = (imageArray) => {
        imageArray.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    };

    useEffect(() => {
        preloadImages(images);
    }, []);

    useEffect(() => {
        const nextSlide = () => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        };

        timeoutRef.current = setTimeout(nextSlide, 6000); // 6 seconds
        return () => clearTimeout(timeoutRef.current);
    }, [currentIndex]);

    const nextImage = () => {
        setCurrentIndex((currentIndex + 1) % images.length);
    };

    const prevImage = () => {
        setCurrentIndex((currentIndex - 1 + images.length) % images.length);
    };
    function gocontant() {
        props.setSelectnav('/contact')
    }
    return (
        <div className="home-container">
            <h1 className='myname'>امیرعلی کاتبی</h1>
            {/* <img src={newyear} className='yalda' alt='2025' loading='lazy'></img> */}
            <div className="wella-slider">
                <div className="slider-content">
                    {images.map((image, index) => (
                        <div
                            className={`slide ${index === currentIndex ? 'active' : ''}`}
                            key={index}
                        >
                            <img
                                src={image}
                                alt={`Slide ${index}`}
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>

                <button className="prev" onClick={prevImage}>
                    &lt;
                </button>
                <button className="next" onClick={nextImage}>
                    &gt;
                </button>

                <div className="indicators">
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={`indicator ${index === currentIndex ? 'active' : ''}`}
                            onClick={() => setCurrentIndex(index)}
                        ></span>
                    ))}
                </div>
                <img className='anarbanner' src={tree} alt='درخت' loading='lazy'></img>
            </div>


            {/* <News /> */}
            {/* <div className='titlebest'>
                <h1>درباره تهران مو</h1>
                <div className='underline'></div>
            </div> */}
            <div className='aboutus'>
                    <div>
                        {props.language === 'en' ? (
                            <>
                                <p>
                                    Tehranmu Company, founded in 1332 with investment from Vala-Darmishtaqat-Germany, is considered one of the 5 largest cosmetics and hygiene companies in the world.
                                    It has led this industry for more than a century.
                                </p>
                                <p>
                                    In 1332, Vala Company established Tehranmu in Iran with fully foreign capital, adhering to the standards of Vela Company.
                                    Over the years, Tehranmu has gained the trust of ambassadors, being the only Iranian cosmetics and hygiene company to market its products under the license of a German company, Sarl, Vela Company.
                                </p>
                                <p>
                                    Additionally, they follow the EC Auria quality standard. The ownership of Vela Company was transferred to PRG Proctelne Compel Co.,
                                    and Tehranmu came under the umbrella of PRG Pro-Catalan Kamil America.
                                </p>
                                <p>
                                    This allowed them to adhere to the standards, formulas, and production procedures of PRG.
                                    Consequently, Tehranmu continues to market its products while maintaining the quality standards of Proctel and Kamil Erica Company.
                                </p>
                                <p>
                                    Tehranmu has established an agency with Schwarzkopf, which allows them to maintain the advanced standards and quality of the Moazzam company.
                                    They have continued to supply products with top-tier formulas to the market.
                                </p>
                                <p>
                                    With this rich history and the use of facilities, standards, formulas, and brands from Vela PRG and Schwarzkopf of Germany,
                                    Tehran Hair produces about 30 global brands, making it one of the largest cosmetics and health companies in Iran and the region.
                                </p>
                                <p>
                                    Due to its long-standing history, Tehran Hair’s products are renowned for their high quality and standards.
                                    The company remains a trusted friend for the third and fourth generations of customers.
                                </p>
                                <p>
                                    Tehran Hair holds more than 1200 production licenses and 30 global brands in its headquarters in Tehran.
                                    It has remained at the forefront of the cosmetic industry through its active participation and innovation.
                                </p>
                                <p>
                                    Tehranmu has consistently supported hairdressers, believing that hairdressing is not merely a service, but rather a form of advanced creativity.
                                    In light of this belief, Tehranmu has established an academic unit for the advancement of hairdressers throughout Iran.
                                </p>
                                <p>
                                    This initiative is under the name of Tehran University of Applied Sciences, focusing on modern science, technology, and collaboration with reputable companies with German names.
                                </p>
                                <p>
                                    The company takes pride in the valuable opportunities it creates in the business environment.
                                    Utilizing all of its resources, Tehranmu is committed to serving the people and contributing to the health of dear Iran.
                                </p>
                            </>
                        ) : (
                            <>
                                <p>
                                    شرکت تهران مو در سال 1332 با سرمایه‌گذاری شرکت والا-دارمشتات-آلمان به عنوان یکی از 5 شرکت بزرگ آرایش و بهداشتی جهان تأسیس شد.
                                    این شرکت بیش از یک قرن پیشتاز این صنعت بوده و در طی این سال‌ها توانسته است موفقیت‌های زیادی کسب کند.
                                </p>
                                <p>
                                    شرکت ولا در سال 1332 اقدام به تأسیس شرکت تهران مو در ایران با سرمایه کاملاً خارجی نمود و با استفاده از استانداردهای شرکت ولا، محصولات خود را به بازار عرضه کرد.
                                    طی سال‌ها، تهران مو به‌عنوان تنها شرکت آرایش و بهداشتی ایرانی محصولات خود را تحت لیسانس یک شرکت آلمانی به نام سارل، شرکت ولا، به بازار عرضه می‌کرد.
                                </p>
                                <p>
                                    علاوه بر این، آنها به استاندارد کیفیت EC Auria نیز پایبند هستند.
                                    مالکیت شرکت ولا به شرکت معظم P&G پروکتر اند گامبل منتقل گردید و شرکت تهران مو تحت پوشش شرکت P&G پروکتلنه کامیل امریکا درآمد.
                                </p>
                                <p>
                                    این امر به آنها این امکان را داد که به استانداردها، فرمول‌ها و رویه‌های تولید P&G پایبند باشند.
                                    در نتیجه، تهران مو همچنان به بازاریابی محصولات خود ادامه می‌دهد و استانداردهای کیفیت شرکت پروکتر و گامبل اریکا را حفظ می‌کند.
                                </p>
                                <p>
                                    شرکت تهران مو اقدام به ایجاد نمایندگی با شوارتکف کرده است که این امکان را برای آنها فراهم می‌کند که استانداردهای پیشرفته و کیفیت شرکت معظم را حفظ کنند.
                                    آنها به عرضه محصولات با فرمول‌های پیشرفته و باکیفیت ادامه داده‌اند.
                                </p>
                                <p>
                                    با توجه به این تاریخچه غنی و استفاده از امکانات، استانداردها، فرمول‌ها و برندهای شرکت ولا P&G و شوارتکف آلمان،
                                    شرکت تهران مو حدود 30 برند جهانی تولید می‌کند و یکی از بزرگترین شرکت‌های آرایشی و بهداشتی در ایران و منطقه به حساب می‌آید.
                                </p>
                                <p>
                                    به خاطر تاریخچه طولانی، محصولات شرکت تهران مو به خاطر کیفیت بالا و استانداردهای خود شناخته شده‌اند.
                                    این شرکت همچنان دوست و همدم نسل‌های سوم و چهارم مشتریان خود است.
                                </p>
                                <p>
                                    شرکت تهران مو بیش از 1200 مجوز تولید و 30 برند جهانی در مرکز خود در تهران دارد.
                                    این شرکت در طول فعالیت خود در صنعت آرایشی همچنان در اوج باقی مانده است.
                                </p>
                                <p>
                                    شرکت تهران مو همواره از آرایشگران حمایت کرده و به این باور است که آرایشگری تنها یک خدمت نیست، بلکه یک خلاقیت پیشرفته است.
                                </p>
                                <p>
                                    بر اساس این باور، شرکت تهران مو واحد دانشگاهی برای پیشرفت آرایشگران در سراسر ایران تأسیس کرده است.
                                </p>
                                <p>
                                    این ابتکار تحت عنوان دانشگاه علمی کاربردی تهران مو با تمرکز بر علم و فناوری مدرن و همکاری با شرکت‌های معتبر با نام‌های آلمانی است.
                                </p>
                                <p>
                                    این شرکت به فرصتی که در محیط کسب‌وکار ایجاد می‌کند افتخار می‌کند.
                                    با استفاده از تمام منابع خود، شرکت تهران مو متعهد به خدمت به مردم و کمک به سلامت عزیزان ایرانی است.
                                </p>
                                <p>جهت اطلاع بیشتر و ارتباط با کارخانه تهران مو به صفحه <Link onClick={gocontant} to='/contact'>تماس با ما</Link> مراجعه کنید.</p>
                            </>
                        )}
                    </div>
                </div>
            <div>
            </div>
            <div className="homebanner">
  <div className="maskbanner"></div>
  <img className="kamandbanner" src={imagebanner} loading="lazy" alt="Kamand Logo" />
  <img className="womanbanner" src={womanbanner} loading="lazy" alt="Standing Woman Pointing Left" />
  <h2 className="banner-text">برند کمند فقط از ما بخواهید</h2>
</div>
        </div>
    );
}
